// Anchor the region to SVG's actual glyph bounds, rather than the authored text
// box. Primitive lengths remain document pixels, including in scaled previews.
export function textEffectFilterRegion(
  width: number,
  height: number,
  padding: number
) {
  const x = padding / Math.max(1, width);
  const y = padding / Math.max(1, height);
  return {
    filterUnits: 'objectBoundingBox' as const,
    primitiveUnits: 'userSpaceOnUse' as const,
    x: -x,
    y: -y,
    width: 1 + x * 2,
    height: 1 + y * 2,
  };
}
